import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { BsPlus } from "react-icons/bs";
import { debounce, get } from "lodash";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import Pagination from "rc-pagination";

import useAxios from "services/useAxios.tsx";

import AddFinanceModel from "./AddFinanceModel";
import { mobileChecker } from "utils/helperFunctions";
import FinanceCard from "./FinanceCard";
import "./finance-style.scss";

const initialAddFinance = {
  bank_account_id: 0,
  type: 0,
  amount: 0,
  account_party_id: 0,
  to_do_time: "",
  tracking: "",
  description: "",
  file: "",
  newUserFname: "",
  newUserLname: "",
  newUserMobile: "",
};

export default function FinanceManagement() {
  const { execute: getBankAccountApi } = useAxios("api/Find_bankAccount");
  const { execute: getUsersApi } = useAxios("financial_operations/get_users");
  const { execute: addTransactionApi } = useAxios(
    "financial_operations/add_manual_transaction"
  );
  const { execute: getTransactionApi } = useAxios(
    "financial_operations/get_manual"
  );
  const { execute: getTransactionTypeApi } = useAxios(
    "financial_operations/get_manual_transaction_type"
  );
  const { execute: cancelTransactionApi } = useAxios(
    "financial_operations/cancel_transaction"
  );

  const [financeModel, setFinanceModel] = useState(false);
  const [addFinanceData, setAddFinanceData] = useState(initialAddFinance);
  const [transactionList, setTransactionList] = useState([]);
  const [bankAccountOption, setBankAccountOption] = useState([]);
  const [usersOption, setUsersOption] = useState([]);
  const [error, setError] = useState({});
  const [listUpdater, setListUpdater] = useState(false);
  const [loaderAdd, setLoaderAdd] = useState(false);
  const [transactionType, setTransactionType] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    count: 10,
    total: 0,
  });

  const changeHandler = (object) => {
    setAddFinanceData((prev) => ({ ...prev, ...object }));
  };
  function formatCreditCardNumber(input) {
    const numericOnly = input?.replace(/\D/g, "");
    const groups = numericOnly?.match(/.{1,4}/g);
    if (groups) {
      return groups.join("-");
    }
    return input;
  }
  const getUserFunc = (text) => {
    getUsersApi({ text: text, page: 1, count: 100 }).then((result) => {
      let userTemp = result?.users ?? [];
      userTemp = userTemp?.map((value) => ({
        value: value?.id,
        label: `${value?.fname} ${value?.lname} (${value?.mobile})`,
      }));
      setUsersOption([{ value: -1, label: "ساخت کاربر جدید" }, ...userTemp]);
    });
  };
  const userDebounce = debounce(getUserFunc, 1000);
  const validation = () => {
    let validate = true;
    let errorTemp = {};
    if (addFinanceData?.bank_account_id == 0) {
      errorTemp = {
        ...errorTemp,
        bank_account: "انتخاب کارت بانکی الزامی است.",
      };
      validate = false;
    } else {
      errorTemp = {
        ...errorTemp,
        bank_account: "",
      };
    }
    if (addFinanceData?.amount == 0) {
      errorTemp = {
        ...errorTemp,
        amount: "وارد کردن مبلغ الزامی است.",
      };
      validate = false;
    } else {
      errorTemp = {
        ...errorTemp,
        amount: "",
      };
    }
    if (addFinanceData?.account_party_id == 0) {
      errorTemp = {
        ...errorTemp,
        account_party: "وارد کردن طرف حساب الزامی است.",
      };
      validate = false;
    } else if (addFinanceData?.account_party_id?.value == -1) {
      if (
        addFinanceData?.newUserFname == "" ||
        addFinanceData?.newUserLname == "" ||
        addFinanceData?.newUserMobile == "" ||
        (addFinanceData?.newUserMobile != "" &&
          !mobileChecker(addFinanceData?.newUserMobile))
      ) {
        errorTemp = {
          ...errorTemp,
          account_party: "",
          account_party_new:
            "وارد کردن نام، نام خانوادگی و موبایل طرف حساب الزامی است.",
        };
        validate = false;
      }
    } else {
      errorTemp = {
        ...errorTemp,
        account_party: "",
        account_party_new: "",
      };
    }
    if (addFinanceData?.to_do_time == "") {
      errorTemp = {
        ...errorTemp,
        to_do_time: "وارد کردن زمان انجام الزامی است.",
      };
      validate = false;
    } else {
      errorTemp = {
        ...errorTemp,
        to_do_time: "",
      };
    }
    if (addFinanceData?.tracking == "") {
      errorTemp = {
        ...errorTemp,
        tracking: "وارد کردن کد رهگیری الزامی است.",
      };
      validate = false;
    } else {
      errorTemp = {
        ...errorTemp,
        tracking: "",
      };
    }
    setError(errorTemp);
    return validate;
  };
  const addTransaction = () => {
    let payload = {
      amount: addFinanceData?.amount,
      from_bank_account_id: addFinanceData?.bank_account_id ?? 0,
      to_user_id: addFinanceData?.account_party_id?.value ?? 0,
      pay_tm: addFinanceData?.to_do_time,
      transaction_type: addFinanceData?.type,
      tracking_code: addFinanceData?.tracking,
      description: addFinanceData?.description,
    };
    if (addFinanceData?.file != "") {
      payload = { ...payload, file_id: addFinanceData?.file };
    }
    if (addFinanceData?.account_party_id?.value == -1) {
      payload = {
        ...payload,
        to_user_fname: addFinanceData?.newUserFname,
        to_user_lname: addFinanceData?.newUserLname,
        to_user_mobile: addFinanceData?.newUserMobile,
      };
    }
    if (validation()) {
      setLoaderAdd(true);
      addTransactionApi(payload).then((result) => {
        if (result?.result?.status) {
          toast.success("تراکنش با موفقیت اضافه شد.");
          setListUpdater((prev) => !prev);
          setFinanceModel(false);
          setPagination((prev) => ({ ...prev, page: 1 }));
        } else {
          toast.error(result?.result?.error);
        }
        setLoaderAdd(false);
      });
    } else {
      console.log("test false");
    }
  };
  const getTransactionFunc = (
    page = pagination?.page,
    count = pagination?.count
  ) => {
    getTransactionApi({ page: page, count: count }).then((result) => {
      setTransactionList(result?.result);
      setPagination((prev) => ({ ...prev, total: result?.total }));
    });
  };
  const cancelFunc = (data) => {
    Swal.fire({
      text: "از ابطال این تراکنش مطمئن هستید؟",
      cancelButtonText: "انصراف",
      confirmButtonText: "بله",
      showCancelButton: true,
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        cancelTransactionApi({ transaction_id: data?.id }).then((result) => {
          if (result?.status == 1) {
            toast.success("تراکنش مورد نظر با موفقیت ابطال شد.");
            setListUpdater((prev) => !prev);
          } else {
            toast.error(result?.msg);
          }
        });
      }
    });
  };
  useEffect(() => {
    getBankAccountApi().then((result) => {
      let temp = result?.map((value) => ({
        label: (
          <div className="font-12-500" dir="rtl">
            <span>{value?.title}</span>
            <span dir="ltr">({formatCreditCardNumber(value?.cardNumber)})</span>
          </div>
        ),
        value: value?.id,
      }));
      setBankAccountOption(temp);
    });
    getTransactionTypeApi().then((result) => {
      let temp = result?.manual_transactions?.map((v) => ({
        value: v?.value,
        label: v?.title,
      }));
      setTransactionType(temp);
    });
    userDebounce("");
  }, []);
  useEffect(() => {
    getTransactionFunc();
  }, [listUpdater, pagination?.page]);
  useEffect(() => {
    setAddFinanceData(initialAddFinance);
  }, [financeModel]);
  console.log("object", pagination);
  return (
    <div className="mx-4 my-3 finance-style">
      <Button
        className="p-2 font-14-500"
        onClick={() => {
          setFinanceModel(true);
        }}
      >
        <BsPlus style={{ width: 18, height: 18 }} />
        افزودن تراکنش
      </Button>
      {transactionList?.length > 0 ? (
        transactionList?.map((value, index) => (
          <FinanceCard
            data={value}
            key={index}
            TRANSACTION_TYPE={transactionType}
            cancelFunc={cancelFunc}
          />
        ))
      ) : (
        <div className="text-center my-2" style={{ fontSize: 14 }}>
          تراکنشی در سیستم ثبت نشده است.
        </div>
      )}
      <Pagination
        className="px-1 text-center my-4"
        total={pagination?.total}
        pageSize={10}
        showTitle={false}
        current={pagination?.page}
        showLessItems={true}
        hideOnSinglePage={true}
        onChange={(newPage) => {
          setPagination((prev) => ({ ...prev, page: newPage }));
        }}
      />
      <AddFinanceModel
        show={financeModel}
        setShow={setFinanceModel}
        options={{
          transaction_type: transactionType,
          bank_account: bankAccountOption,
          users_options: usersOption,
        }}
        data={addFinanceData}
        changeHandler={changeHandler}
        userDebounce={userDebounce}
        addTransaction={addTransaction}
        error={error}
        loaderAdd={loaderAdd}
      />
    </div>
  );
}
